import { AuthAPI, AxiosRepository } from "ftl-core";
import { API_BASE_URL } from "../auth/routers/AuthRouter";
const CredentialRepository = AxiosRepository({
    baseUrl: API_BASE_URL,
    tokenRefresh: () => AuthAPI.refresh(),
});
export default CredentialRepository;
//# sourceMappingURL=CredentialRepository.js.map